import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';

export function useGridBuyboxRedesignCTAExp() {
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_GRID_REDESIGN_CLICK');

	const { country } = useLanguageStore();

	function setGridRedesignTags(url: ClickoutUrl, placement: 'ft' | 'ro', shortName: string, inline?: boolean) {
		if (!variant.value || inline) return url;

		if (!['atp', 'amp', 'prv', 'hlu', 'cru'].includes(shortName)) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: country.value,
			placement,
			providerShortName: shortName,
		});

		return url.set('uct_ctag', tag);
	}

	return {
		setGridRedesignTags,
	};
}
